<template>
  <div>
    <span
      v-if="show"
    >{{ text }}</span>
    <v-icon
      v-else
      color="primary"
      small
      class="icon-btn"
      @click.stop="show = true"
    >
      visibility_off
    </v-icon>
  </div>
</template>

<style lang="scss" scoped>
.icon-btn:hover {
  cursor: pointer;
}
</style>

<script>
  export default {
    props: {
      text: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        show: false,
      };
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/elements/HiddenText.vue